// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F5QP6YRGxiMUWfiYsuAI{border-bottom:1px solid var(--border-neutral-default);width:100%;padding:24px 64px 0;display:flex}.h9yKicco_iwOsEXCXEQA{cursor:pointer;border-bottom:2px solid transparent;padding:8px 8px 14px;transition:border-bottom-color .3s}.h9yKicco_iwOsEXCXEQA:hover,.h9yKicco_iwOsEXCXEQA.xqeBdsDh97ow4Af8snbd{border-bottom-color:var(--background-brand-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview__tabs": `F5QP6YRGxiMUWfiYsuAI`,
	"previewTabs": `F5QP6YRGxiMUWfiYsuAI`,
	"preview__tab": `h9yKicco_iwOsEXCXEQA`,
	"previewTab": `h9yKicco_iwOsEXCXEQA`,
	"active": `xqeBdsDh97ow4Af8snbd`
};
export default ___CSS_LOADER_EXPORT___;
